export const expandRightToolbar = dialog => {
  return {
    type: 'RIGHT_TOOLBAR_EXPAND',
    payload: dialog
  }
}

export const collapseRightToolbar = () => {
  return {
    type: 'RIGHT_TOOLBAR_COLLAPSE'
  }
}
export const hideRightToolbar = () => {
  return {
    type: 'RIGHT_TOOLBAR_HIDE'
  }
}

export const showRightToolbar = () => {
  return {
    type: 'RIGHT_TOOLBAR_SHOW'
  }
}

